export default __webpack_public_path__ + "static/media/Neophyte's Gloves of Regal Might.62261fc8.jpg";